






import { Component, Vue } from 'vue-property-decorator';
import Search from '@arcgis/core/widgets/Search';
import LayerSearchSource from '@arcgis/core/widgets/Search/LayerSearchSource';
import LocatorSearchSource from '@arcgis/core/widgets/Search/LocatorSearchSource';
import Locator from '@arcgis/core/tasks/Locator';

@Component
export default class EsriSearch extends Vue {

    get searchLayer() {
        return this.$store.state.search.layer;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    get novaScotiaLocator() {
        return this.$store.state.novaScotiaLocator;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initSearch') {
            this.initSearch();
        }
    });

    public initSearch() {
        console.log('EsriSearch: initSearch()');
        const locatorSearchSource: __esri.LocatorSearchSource = new LocatorSearchSource({
            locator: new Locator({url: this.novaScotiaLocator.url}),
            singleLineFieldName: 'SingleLine',
            name: this.novaScotiaLocator.name,
            placeholder: this.novaScotiaLocator.placeholder,
            maxResults: 3,
            maxSuggestions: 6,
            suggestionsEnabled: true,
            minSuggestCharacters: 0,
        });

        const layerSearchSource: __esri.LayerSearchSource = new LayerSearchSource({
            layer: this.searchLayer,
            searchFields: ['EnglishName', 'SmithName'],
            // displayField: 'name',
            suggestionTemplate: '{EnglishName}: {SmithName}',
            exactMatch: false,
            outFields: [
                'SmithName',
                'SmithName2',
                'EnglishName',
                'County',
                'SmithProperTranslation',
                'name1',
                'meaning1',
                'source1',
                'source_detail1',
                'name2',
                'meaning2',
                'source2',
                'source_detail2',
                'name3',
                'meaning3',
                'source3',
                'source_detail3',
                'name4',
                'meaning4',
                'source4',
                'source_detail4',
                'name5',
                'meaning5',
                'source5',
                'source_detail5',
                'Comment',
                'AudioLink',
                'Video',
            ],
            name: 'Mi\'kmaw Place Name',
            placeholder: 'Mi\'kmaw Place Name',
        });

        const searchWidget: __esri.widgetsSearch = new Search({
            view: this.mapView,
            allPlaceholder: 'Search',
            activeSourceIndex: 1, // unlselect ESRI world geocoder
            searchAllEnabled: false,
            includeDefaultSources: false,
            sources: [locatorSearchSource, layerSearchSource],
            popupEnabled: false,
            locationEnabled: false,
        });

        // @ts-ignore this is valid but esri types thinks 'select-result' is missing
        searchWidget.on('select-result', (response: any) => {
            if (response && response.source && response.source.name === 'Nova Scotia Geocoder') {
                // don't do anything with geocoding responses
            } else if (response && response.result && response.result.feature) {
                console.log(response.result.feature);
                this.$store.dispatch('popupFromSearch', response.result.feature);
            }
        });

        this.mapView.ui.add(searchWidget, {
          position: 'top-right',
        });
        // I don't know why we can't set this in the widget properies
        // @ts-ignore
        searchWidget.domNode.style = 'width: 300px';
    }

    public mounted() {
        console.log('EsriSearch: mounted()');
        // init only when the map is ready, not when the component is mounted
    }

    public beforeDestroy() {
        this.unsubscribe();
    }
}

